import { Injectable } from '@angular/core';
import { AppService } from '../app.service';
import { firstValueFrom } from 'rxjs';

type extensionModel = { refNo: any, extensionFor: string, subTaskNo?: any }
@Injectable()

export class qmsService {

  constructor(private readonly appService: AppService) { };

  /* primary variables */
  refereshBreadCrumb: boolean;
  topNavModule: any = "";
  noteIcon = '../../assets/img/info-yellow.png';

  /*   This variables is mandatory before launching the quality modules */
  selectedActivityGroupId: any = null;
  selectedGroup: any = "";
  selectedGroupDetailData: any = {};
  selectedGroupDetailId: any;
  moduleName: any = null;
  moduleFullName: any = null;
  activityId: any = null;
  loggedInitiaor: boolean; /* validation inprogress */

  /*   This variables is mandatory after launching quality modules */
  activityTitle: any = ";"
  activityDynamicButtonList: string[] = [];
  getOneQmsOrgUsersDetails: any = {};
  activity: any = {};
  activityButtonLabels: any = [];
  activitySaveButton: boolean;
  activityDynamicLabel: any;
  elite_AccessToClosure_Reviewer_Approver: boolean;

  /*Members of CR Family */
  crPageAllDropdownValues: any = {
    departmentValue: null,
    changeTypeValue: null,
    ownerValue: null,
    requestedAtValue: null,
    coreBusinessAreaNameValue: [],
    qaUserValue: null,
    reasonForChangeValue: [],
    departmentHeadUserValue: null
  }
  validatedCrArray: any = [];
  isUpdatingCrThroughDynBtn: boolean;
  crTabIndex: number = 0;

  /*Members of CAPA Family */
  capaPageAllDropdownValues: any = {
    departmentValue: null,
    ownerValue: null,
    capaTypeValue: null,
    requestedAtValue: null,
    coreBusinessAreaNameValue: [],
    qaUserValue: null,
    reasonForCapaValue: [],
    selectedRootCauseCategory: []
  }
  validatedCapaArray: any = [];
  isUpdatingCapaThroughDynBtn: boolean;
  capaTabIndex: number = 0;

  /*Members of DV Family */
  dvPageAllDropdownValues: any = {
    departmentValue: null,
    ownerValue: null,
    deviationTypeValue: null,
    requestedAtValue: null,
    coreBusinessAreaNameValue: [],
    qaUserValue: null,
    reasonForDeviationValue: [],
    dvRootCauseCategory: [],
    investigationTechnique: null,
    deviationCriticality: null,
  }
  validatedDvArray: any = [];
  isUpdatingDvThroughDynBtn: boolean;
  dvTabIndex: number = 0;

  /*Members of QI Family */
  qiDropDowns: any = {
    selectedQiDepartment: null,
    selectedQiReference: null,
    selectedQiType: null,
    selectedQiRequestedAt: null,
    selectedQiCoreBusinessArea: [] as string[] | string,
    selectedQiImpactType: null,
    selectedQiQa: null,
    selectedQiEvaluator: null,
    selectedQiInvestigator: null,
    selectedQiRootCauseType: [],
    selectedQiResolutionCategory: null,
  }
  validatedQiArray: any = [];
  validateQiAntiDraftFields: boolean;
  isUpdatingQiThroughDynBtn: boolean;

  /*Members of IN Family */
  incidentDropDowns: any = {
    selectedIncidentType: null,
    selectedDepartment: null,
    selectedReference: null,
    selectedRequestedAt: null,
    selectedBusinessArea: [] as string[] | string,
    selectedBehalfOfOthers: null,
    selectedImpactType: null,
    selectedEvaluator: null,
    selectedInvestigator: null,
    selectedRootCauseType: [],
    selectedResolutionCategory: null,
  }
  validatedIncidentArray: any = [];
  isUpdatingIncidentThroughDynBtn: boolean;
  isUpdatingAUThroughDynBtn: boolean;

  /*Members of CC Family */
  ccDropDowns: any = {
    selectedGroup: null,
    selectedReporterType: null,
    selectedReporterCountry: null,
    selectedNatureOfComplaint: null,
    selectedDepartment: [],
    selectedLocations: null,
    selectedReportedComplaintType: [],
    selectedSourceOfComplaint: null,
    selectedEvaluator: null,
    selectedCompanyComplaintType: null,
    selectedInvestigator: null,
    selectedInvestigationTechnique: null,
    selectedMarketAction: null,
    selectedFinalCompanyComplaintType: null,
    selectedFinalComplaintCategory: [],
    selectedMethodOfResponse: [],
    selectedReimbursementType: null,
    selectedReimbursementStatus: null,
    selectedResponseStatus: null,
    selectedQA: null
  }
  validatedCcArray: any = [];
  isUpdatingCcThroughDynBtn: boolean;
  ccTabIndex: number = 0;

  /*Members of OOS Family */
  oosDropdowns: any = {
    selectedInstrumentId: []
  }
  validatedOosArray: any = [];
  isUpdatingOosThroughDynBtn: boolean;
  oosTabIndex: number = 0;
  isChangeDetectedInOos: boolean = false;

  /*Members of AU Family */
  validatedAuArray: any = [];
  isUpdatingAuThroughDynBtn: boolean;
  validatedFindingArray: any = [];
  iUpdatingFindingThroughDynBtn: boolean;
  selectedRiskModule: any = [];

  /* KIDS */
  ecDropdowns: any = {
    selectedOwner: [],
    selectedApprover: [],
    selectedQAApprover: []
  }

  /*  Decision Pending */
  isInvestigationSaveButtonReq: boolean;
  onlyReviewerApproverEditable: boolean = false;
  noOfActionOfDocuments: number;

  allowAddandEditForExtension: boolean;
  loggedOwner: boolean;
  userRole: any = {};
  cancelButtonFrom: any;
  getFlexifieldsListofData: any = [];
  getQmsActionDataUsingById: any = [];
  previousFilteredFlexifieldsList: any = [];
  additionalDetailsDynamicSaveButton: boolean = false;
  auFindings: boolean = false;
  newlyAddedCapaDataFromAu: any;
  capaIdForFindingReference: any;
  auditEditmodeDatas: any;
  selectedTabName: any;
  reportFor: any;
  landToDocumentsAutomatically: boolean;
  adminReportFor: any;
  formsAndLogsReportFor: any;
  findingDetailsForCapaDescription: any;
  taskModuleName: any;
  trainingReportFor: any;
  isTriggeredFromDependencies: boolean = false;
  auFindingsList: any;
  isCapaTriggeredFromFindingPage: boolean;
  capaIdForFindingDetailsPage: any;
  showRiskButtons: boolean;
  loggedQa: boolean;
  loggedAuditor: boolean;
  isSwitchUSerPopupOpened: boolean = false;
  saveDataUsingDynamicButtons: boolean;
  auQuestionarie: any;

  clickedButton: any;
  SelectedGroupNameAndValue: any = [];
  groupNameAndValue: any = [];
  showTopNav: any;
  userModuleList: any = [];
  userModuleList1: any = [];
  tempModule: any;
  tempActivityId: any;
  tempactivitybuttonDetails: any;
  tempselectedGroupDetailId: any;
  tempflexifieldDataList: any;
  tempoverallFlexifieldList: any;

  highlightBackground: number | null = null; // NOT undefined

  tempSelectedOrginizationName: any = null;
  tempSelectedStatus: any = "";

  workflowId: any;
  parallelworkflowStatus: any;
  currentFindings: any;

  selectedExtensionReview: any = null;
  selectedExtensionApprove: any = null;

  selectedAuditType: any;


  loggeduserid: any;




  showflexifieldshow: boolean;

  showGridSection: boolean = false;
  showReportSection: boolean = false;
  showAuditMasterSection: boolean = false;
  showVendorMasterSection: boolean = false;
  highlightgridsection: any = true;
  highlightReportSection = false;
  defaultGroupList: any;
  isFieldInCurrentStatus: boolean = false;




  selectedSearchUserName: string = '';
  selectedSearchUserId: number;

  isCopyingRisk: boolean = false;


  showmodulegrid: boolean = true;

  capaDetailsForFindingDetails: any;

  dynamicLabel: any = [];
  extensionResult: string = '';
  isProcessing: boolean = false;
  validSwitchStatus: boolean = false;

  public async validateExtension(model: extensionModel): Promise<boolean> {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // strip time


    const closureDate = new Date(this.activity.expcetedClosureOn);
    closureDate.setHours(0, 0, 0, 0);
    this.isProcessing = true;

    if (today > closureDate && this.selectedGroupDetailData?.isExtensionRequired == 'Y') {
      this.extensionResult = "The activity closure date has passed. Please extend the date to proceed!";
      return true;
    } else {
      let extension: any = await firstValueFrom(this.appService.getAllExtensionsByRefNo(model.refNo));
      if (!extension.length) return false;
      if (model.extensionFor == "Activity") {
        extension = extension.filter((x: any) => x.extensionType == "Overall Activity")
      } else if (model.extensionFor == "Action") {
        extension = extension.filter((x: any) => x.extensionType == "Action")
      } else if (model.extensionFor == "Findings") {
        extension = extension.filter((x: any) => x.extensionType == "Findings")
      }
      this.extensionResult = "Extension is in InProgress. Please complete to proceed further!";
      if (model.extensionFor === "Activity") {
        return extension.some((item: any) => item.status !== "Approved");
      }
      return extension.some((item: any) => item.actionId === model.subTaskNo && item.status !== "Approved");
    }
  }

  public $preActionsAestheticResolver(params: {
    status: string;
    isInitiator: boolean;
    isOwner: boolean;
    isEvaluator: boolean;
    isDeptHead: boolean;
    isEditableByDeptHead: boolean;
    isQa: boolean;
    isEditableByQa: boolean;
    isInvestigator: boolean;
    isEditableByInvestigator: boolean;
    isReviewer: boolean;
    isEditableByReviewer: boolean;
    isApprover: boolean;
    isEditableByApprover: boolean;
    ccHandler: boolean;
  }): boolean {

    const p = params;

    switch (p.status) {

      case 'Draft':
      case 'Department Head Requested More Info.':
      case 'Department Head Rejected':
      case 'QA Requested More Info.':
      case 'QA Acceptance Rejected':
      case 'Owner Requested More Info.':
      case 'More Information Requested By Evaluator':
        return !!p.isInitiator;

      case 'Owner Acknowledged':
      case 'Revoked':
      case 'Reopened':
        return !!p.isOwner;

      case 'Evaluation Completed':
      case 'Complaint Accepted':
      case 'Logged':
      case 'Investigator Requested More Information':
      case 'QA Approved':
        return !!p.isEvaluator;

      case 'Pending Department Head Approval':
        return !!(p.isDeptHead && p.isEditableByDeptHead);

      case 'Pending QA Acceptance':
      case 'Pending QA Approval':
        return !!(p.isQa && p.isEditableByQa);

      case 'Investigation Pending':
      case 'Reinvestigation Requested':
        return !!(p.isInvestigator && p.isEditableByInvestigator);

      case 'Investigation Completed':
        if (this.moduleName == 'CC') {
          return !!p.ccHandler;
        } else {
          return !!p.isEvaluator;
        }

      case 'Pending Review':
      case 'Review Inprogress':
        return !!(p.isReviewer && p.isEditableByReviewer);

      case 'Pending Approval':
      case 'Approval Inprogress':
        return !!(p.isApprover && p.isEditableByApprover);

      case 'Reviewer Requested More Info.':
      case 'Review Rejected':
      case 'Approver Requested More Info.':
      case 'Approval Rejected':
      case 'Closure Reviewer Requested More Info.':
      case 'Closure Review Rejected':
      case 'Closure Approver Requested More Info.':
      case 'Closure Approval Rejected':
      case 'QA Rejected':
        if (this.moduleName == 'CR' || this.moduleName == 'CAPA' || this.moduleName == 'DV') {
          return !!p.isOwner;
        } else {
          return !!p.isEvaluator;
        }

      default:
        return false;
    }
  }


}
